/**
 * Cartel de error de una acción, arriba de la tabla.
 *
 * A diferencia del error de carga (que reemplaza la página entera, porque no
 * hay nada que mostrar), este NO destruye la tabla: si falló autorizar una
 * fila, las otras siguen siendo válidas y usables. Ver useAccion.ts.
 */
interface Props {
  mensaje: string | null;
  onCerrar: () => void;
}

export function AvisoError({ mensaje, onCerrar }: Props) {
  if (!mensaje) return null;
  return (
    <div className="aviso-error" role="alert">
      <span>{mensaje}</span>
      <button className="aviso-error-cerrar" onClick={onCerrar} aria-label="Cerrar aviso">
        ×
      </button>
    </div>
  );
}
